/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Link from '../partials/Link';
import Image from '../partials/Image';

import styles from '../../../styles/blocks/team.module.scss';

const propTypes = {
    title: PropTypes.string,
    members: AppPropTypes.teamMembers,
    small: PropTypes.bool,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    members: [],
    small: false,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const TeamBlock = ({ title, members, className, small, isContainer, containerClassName }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div
            className={classNames([
                'blockTeam',
                styles.inner,
                {
                    [styles.isContainer]: isContainer && !small,
                    [styles.isSmall]: small,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            {title !== null ? <h2 className={styles.title}>{title}</h2> : null}
            <div className={styles.members}>
                {members.map((m, i) => {
                    const { role = null, name = null, email = null, image = null } = m || {};
                    const { url = null } = image || {};
                    return (
                        <div className={styles.member} key={`team-${name}-${role}-${i + 1}`}>
                            {url !== null ? (
                                <Image className={styles.picture} media={image} alt={name} />
                            ) : (
                                <div className={classNames(styles.picture, styles.fallback)} />
                            )}
                            <div className={styles.info}>
                                {name !== null ? <div className={styles.name}>{name}</div> : null}
                                {role !== null ? <div className={styles.role}>{role}</div> : null}
                                {email !== null ? (
                                    <Link
                                        href={`mailto:${email}`}
                                        className={styles.email}
                                        external
                                    >
                                        {email}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </div>
);

TeamBlock.propTypes = propTypes;
TeamBlock.defaultProps = defaultProps;

export default TeamBlock;
